import { getFilterTabSx, getFilterToggleSx, formatStatusLabel } from '../hpcAdminStatusStyles';

export const ASSESSMENT_STATUS_CHIP_STYLES = {
  draft: { bg: '#f5a623', color: '#1a1200', border: '#f5a623' },
  completed: { bg: '#2e7c67', color: '#ffffff', border: '#4cceac' },
  reviewed: { bg: '#1976d2', color: '#ffffff', border: '#4dabf7' },
};

export const getAssessmentStatusChipSx = (status) => {
  const style = ASSESSMENT_STATUS_CHIP_STYLES[status] || {
    bg: '#525252',
    color: '#f0f0f0',
    border: '#858585',
  };
  return {
    backgroundColor: style.bg,
    color: style.color,
    border: `1px solid ${style.border}`,
    fontWeight: 700,
    textTransform: 'capitalize',
  };
};

export { getFilterTabSx, getFilterToggleSx, formatStatusLabel };

export const assessmentFilterToApi = (value) => (value === 'all' ? '' : value);
